import { TRACKER_HEALTH_DEFAULTS } from '@chukua/common';

export type TruckMapStatus = 'moving' | 'stopped' | 'late' | 'silent';

export const TRUCK_MAP_STATUSES: TruckMapStatus[] = ['moving', 'stopped', 'late', 'silent'];

export const TRUCK_MAP_STATUS_LABELS: Record<TruckMapStatus, string> = {
  moving: 'Moving',
  stopped: 'Stopped',
  late: 'Late',
  silent: 'Silent',
};

/**
 * The API's tracker-health numbers, shared through `TRACKER_HEALTH_DEFAULTS`: a report is expected every minute (the push-only
 * assumption, because the map has no polling interval per truck), late after 3 missed and silent after 10.
 */
const EXPECTED_REPORT_MS = TRACKER_HEALTH_DEFAULTS.pushOnlyExpectedIntervalSeconds * 1000;
export const LATE_AFTER_MS = TRACKER_HEALTH_DEFAULTS.lateAfterIntervals * EXPECTED_REPORT_MS;
export const SILENT_AFTER_MS = TRACKER_HEALTH_DEFAULTS.silentAfterIntervals * EXPECTED_REPORT_MS;

/** Below walking pace, a truck is standing: GPS speed drifts a little even when parked. */
export const STOPPED_BELOW_MPS = 1;

interface StatusInput {
  speedMps: number | null;
  deviceTime: string;
}

/**
 * What the map shows for a truck, from its last fix and the clock. Derived on every tick rather than stored, so a truck that stops
 * reporting turns late and then silent without anything being sent about it. A fix with no speed is not claimed to be moving.
 */
export function truckMapStatus({ speedMps, deviceTime }: StatusInput, now: Date): TruckMapStatus {
  const ageMs = now.getTime() - new Date(deviceTime).getTime();
  if (ageMs >= SILENT_AFTER_MS) return 'silent';
  if (ageMs >= LATE_AFTER_MS) return 'late';
  return speedMps !== null && speedMps >= STOPPED_BELOW_MPS ? 'moving' : 'stopped';
}
